import { Injectable } from "@angular/core";
import { AuthServiceStrategy } from "./auth-service-strategy";
import { BearerAuthService } from "./bearer-auth-service";
import { BasicAuthService } from "./basic-auth-service";
import { AuthType } from "../../shared/enums/AuthType.enum";

@Injectable({ providedIn: 'root' })
export class AuthStrategyFactory {

  constructor(
    private bearerAuth: BearerAuthService,
    private basicAuth: BasicAuthService
  ) {}

  create(type: AuthType): AuthServiceStrategy {
    switch (type) {
      case AuthType.BEARER:
        return this.bearerAuth;
      case AuthType.BASIC:
        return this.basicAuth;
      default:
        throw new Error('Unsupported auth strategy');
    }
  }

}
